module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_7005.7b932c79.png";